//GET DEPARTMENT USERS
export const GET_DEPARTMENT_USERS_REQUEST = 'GET_DEPARTMENT_USERS_REQUEST';
export const GET_DEPARTMENT_USERS_SUCCESS = 'GET_DEPARTMENT_USERS_SUCCESS';
export const GET_DEPARTMENT_USERS_FAIL = 'GET_DEPARTMENT_USERS_FAIL';

//GET USER DEPARTMENT
export const GET_USERS_DEPARTMENT_REQUEST = 'GET_USERS_DEPARTMENT_REQUEST';
export const GET_USERS_DEPARTMENT_SUCCESS = 'GET_USERS_DEPARTMENT_SUCCESS';
export const GET_USERS_DEPARTMENT_FAIL = 'GET_USERS_DEPARTMENT_FAIL';
